// Languages of the site. EN and DE are hand-maintained (english.ts,
// german.ts, landing.ts); the others are translations of the English copy in
// config/i18n/locales/<code>/. Order = order of the language menu.
export const SITE_LANGS = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "es", label: "Español" },
  { code: "it", label: "Italiano" },
  { code: "pl", label: "Polski" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
] as const;

/** Code shown to people (menu, judojama.com URL folder). The ISO 639-1
 *  code stays in lang/hreflang; JA/KO read like country codes JP/KR. */
const SHORT: Partial<Record<string, string>> = { ja: "jp", ko: "kr", uk: "ua" };
export const shortCode = (lang: string): string => SHORT[lang] || lang;

export type Lang = typeof SITE_LANGS[number]["code"];

export const isLang = (value: string | null | undefined): value is Lang =>
  SITE_LANGS.some((item) => item.code === value);

/** Value for the lang attribute (Chinese is Simplified Chinese). */
export const htmlLang = (lang: Lang): string => (lang === "zh" ? "zh-Hans" : lang);
